export default __webpack_public_path__ + "static/media/bg1.d1d1f014.jpg";